// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"280":"4e8dc38d","358":"775dfa80","778":"4e8dc38d"}[chunkId] + ".chunk.css";
};